import type { ContentProfile } from '@content-planner/shared';

const DRAFT_KEY = 'cp:draft-v1';

export type WizardDraft = {
  profile: Partial<ContentProfile>;
  month?: string;
};

export const draftStorage = {
  load(): WizardDraft | null {
    try {
      const raw = sessionStorage.getItem(DRAFT_KEY);
      return raw ? (JSON.parse(raw) as WizardDraft) : null;
    } catch {
      return null;
    }
  },

  save(draft: WizardDraft): void {
    try {
      sessionStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch {
      // sessionStorage unavailable (private mode, etc) - ignore
    }
  },

  clear(): void {
    try {
      sessionStorage.removeItem(DRAFT_KEY);
    } catch {
      // ignore
    }
  },
};
